import * as React from "react";

const ArrowNextIcon = (props) => (
  <svg
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M14 5.996 8.182 0v3.577H6.945C3.109 3.577 0 6.5 0 10.104V12l.55-.566c1.867-1.923 4.51-3.02 7.282-3.02h.35v3.578L14 5.996Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowNextIcon;
